@if (userPermission?.parsedRole.zl_admin) {
  <div class="footer">
    <span>
      <button (click)="openServersVersion()">Servers version</button>
    </span>
    <span>
      <button (click)="openPlatformDisruptions()">Platform disruptions</button>
    </span>
    @if (buildInfo?.version) {
      <span> Version: {{ buildInfo?.version }} </span>
    }
    @if (buildInfo?.timestamp) {
      <span>
        Build time:
        {{ asDate(buildInfo?.timestamp) | localizedDateTime }}
      </span>
    }
    @if (buildInfo?.git?.hash && buildInfo?.git?.fullHash) {
      <span>
        <button [cdkCopyToClipboard]="buildInfo?.git?.fullHash">
          Commit: {{ buildInfo?.git?.hash }}
        </button>
      </span>
    }
    <span> Environment: {{ environment.platform }} </span>
    <span>
      Prod flag:
      {{ environment.production ? 'production 🏭' : 'development 🚧' }}
    </span>
    <span>
      Sentry enabled: {{ environment.sentryEnabled }}
      <button (click)="testSentry()">Test sentry</button>
    </span>
    <span> GA enabled: {{ environment.gaEnabled }} </span>
    <span>
      <button (click)="goToMatomo()">Matomo</button>
    </span>
    <span class="jwt">
      <button [cdkCopyToClipboard]="getToken()">Copy JWT</button>
    </span>
    <span>
      <button (click)="syncLutz()">Sync Lutz</button>
    </span>
    @if (currentJobsite) {
      <span>
        Jobsite: <button (click)="openJobsiteDevInfo()">Admin</button>
      </span>
      <span>
        Layout history:
        <button (click)="downloadLayoutHistory()">Download</button>
      </span>
    }
  </div>
}
